import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import multiguard from "vue-router-multiguard";

import axios from "axios";
axios.create({
  baseURL: "https://api.pirls.ir/",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  }
});

// views
import Home from "../views/Home.vue";
import Buy from "../views/Buy.vue";
import Books from "../views/Books.vue";
import Book from "../views/Book.vue";
import Restricted from "../views/Restricted.vue";
import PortalNotExist from "../views/PortalNotExist.vue";
import SchoolRegister from "../views/SchoolRegister.vue";

// auth components
import Signin from "../components/Auth/Signin.vue";
import Signup from "../components/Auth/Signup.vue";
import SetSchoolPassword from "../components/Auth/SetSchoolPassword.vue";
import ForgotPassword from "../components/Auth/ForgotPassword.vue";

// profile views
import Profile from "../views/Profile/Profile.vue";
import MyExams from "../views/Profile/MyExams.vue";
import MyOrders from "../views/Profile/MyOrders.vue";

// bank views
import Checkout from "../views/Checkout.vue";
import OrderVerify from "../views/Verify.vue";

// admin section :
import Agents from "../views/Admin/Agents.vue";
import Tester from "../views/Admin/Tester.vue";
import Supervisors from "../views/Admin/Supervisors.vue";
//// Users
import UsersLists from "../views/Admin/Users/UsersLists.vue";
import UsersReport from "../views/Admin/Users/UsersReport.vue";
import UserStateReports from "../views/Admin/Users/UserStateReports.vue";
//// Payments
import Payments from "../views/Admin/Payments/Payments.vue";
import PaymentsReport from "../views/Admin/Payments/PaymentsReport.vue";
import PaymentsStateReport from "../views/Admin/Payments/PaymentsStateReport.vue";
import PaymentsCityReport from "../views/Admin/Payments/PaymentsCityReport.vue";
import UsersPayments from "../views/Admin/Payments/UsersPayments.vue";
import SchoolsPayments from "../views/Admin/Payments/SchoolsPayments.vue";
//// Exams
import ExamsReport from "../views/Admin/Exams/ExamsReport.vue";
import ExamStateReports from "../views/Admin/Exams/ExamStateReports.vue";
import ExamCityReports from "../views/Admin/Exams/ExamCityReports.vue";
//// Schools
import ActiveSchools from "../views/Admin/Schools/ActiveSchools.vue";
import ActivedSchools from "../views/Admin/Schools/ActivedSchools.vue";
//// Schools
import Portals from "../views/Admin/Portals/Portals.vue";
import EditPortal from "../views/Admin/Portals/Edit.vue";
import SummeryPortal from "../views/Admin/Portals/Summery.vue";

// Portal views
import Portal from "../views/Portal/Portal.vue";
import PortalPayments from "../views/Portal/Payments.vue";
import PortalStudents from "../views/Portal/Students.vue";

// supervisor views
import SupervisorUsers from "../views/Supervisor/Users.vue";

// agents views
import AgentActiveSchools from "../views/Agent/ActiveSchools.vue";
import AgentActivedSchools from "../views/Agent/ActivedSchools.vue";
import AgentPayments from "../views/Agent/Payments.vue";

// schools views
import CreateSchoolOrder from "../views/School/CreateSchoolOrder.vue";
import DiscountReport from "../views/School/DiscountReport.vue";
import SchoolOrders from "../views/School/SchoolOrders.vue";

// books components
import Reading from "../components/Books/Reading.vue";
import Listening from "../components/Books/Listening.vue";
import Watching from "../components/Books/Watching.vue";
import Exam from "../components/Books/Exam.vue";
import Report from "../components/Books/Report.vue";
import Certificate from "../components/Books/Certificate.vue";

import {
  requireAdminAuth,
  requireSchoolAuth,
  requireAgentAuth,
  requireSuperviosrAuth,
  requirePortalAuth,
  requireAuth,
  loginedUser,
  perchasedBook,
  hasNoExam
} from "../AuthGuard";

// clear error state
const preChecks = (to, from, next) => {
  store.commit("clearMessageState");
  var portal = store.getters.portal;
  if (portal) next();
  else {
    const url = window.location.origin;
    axios
      .post("portal", {
        origin: url
      })
      .then((res) => {
        portal = res.data.portal;
        if (portal) {
          next();
        } else {
          next({ name: "PortalNotExist" });
        }
      });
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: preChecks
  },
  {
    path: "/Login",
    name: "Signin",
    component: Signin,
    meta: {
      layout: "none"
    },
    beforeEnter: multiguard([preChecks, loginedUser])
  },
  {
    path: "/Register",
    name: "Signup",
    component: Signup,
    meta: {
      layout: "none"
    },
    beforeEnter: multiguard([preChecks, loginedUser])
  },
  {
    path: "/SetPassword",
    name: "SetPassword",
    component: SetSchoolPassword,
    meta: {
      layout: "none"
    },
    beforeEnter: multiguard([preChecks, loginedUser])
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      layout: "none"
    },
    beforeEnter: multiguard([preChecks, loginedUser])
  },
  {
    path: "/Profile",
    name: "Profile",
    component: Profile,
    beforeEnter: multiguard([preChecks, requireAuth])
  },
  {
    path: "/School/Add",
    name: "CreateSchoolOrder",
    component: CreateSchoolOrder,
    beforeEnter: multiguard([preChecks, requireSchoolAuth])
  },
  {
    path: "/School/Orders",
    name: "SchoolOrders",
    component: SchoolOrders,
    beforeEnter: multiguard([preChecks, requireSchoolAuth])
  },
  {
    path: "/School/Report/:id",
    name: "DiscountReport",
    component: DiscountReport,
    beforeEnter: multiguard([preChecks, requireSchoolAuth])
  },
  // admin section:
  {
    path: "/Admin/Agents",
    name: "Agents",
    component: Agents,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/Tester",
    name: "Tester",
    component: Tester,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/Supervisors",
    name: "Supervisors",
    component: Supervisors,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //// Users
  {
    path: "/Admin/UsersLists",
    name: "UsersLists",
    component: UsersLists,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/UsersReport",
    name: "UsersReport",
    component: UsersReport,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/UserStateReports",
    name: "UserStateReports",
    component: UserStateReports,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //// Payments
  {
    path: "/Admin/Payments",
    name: "Payments",
    component: Payments,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/PaymentsReport",
    name: "PaymentsReport",
    component: PaymentsReport,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/PaymentsStateReport/:id",
    name: "PaymentsStateReport",
    component: PaymentsStateReport,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/PaymentsCityReport/:stateId/:id",
    name: "PaymentsCityReport",
    component: PaymentsCityReport,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/UsersPayments",
    name: "UsersPayments",
    component: UsersPayments,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/SchoolsPayments",
    name: "SchoolsPayments",
    component: SchoolsPayments,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //// Exams
  {
    path: "/Admin/ExamsReport",
    name: "ExamsReport",
    component: ExamsReport,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/ExamStateReports/:id",
    name: "ExamStateReports",
    component: ExamStateReports,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/ExamCityReports/:stateId/:id",
    name: "ExamCityReports",
    component: ExamCityReports,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //// Schools
  {
    path: "/Admin/ActiveSchools",
    name: "ActiveSchools",
    component: ActiveSchools,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/ActivedSchools",
    name: "ActivedSchools",
    component: ActivedSchools,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //// Portals
  {
    path: "/Admin/Portals",
    name: "Portals",
    component: Portals,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/Portal/Edit/:id",
    name: "EditPortal",
    component: EditPortal,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  {
    path: "/Admin/Portal/Summery/:id",
    name: "SummeryPortal",
    component: SummeryPortal,
    beforeEnter: multiguard([preChecks, requireAdminAuth])
  },
  //////
  {
    path: "/Supervisor/Users",
    name: "SupervisorUsers",
    component: SupervisorUsers,
    beforeEnter: multiguard([preChecks, requireSuperviosrAuth])
  },
  {
    path: "/Agent/ActiveSchools",
    name: "AgentActiveSchools",
    component: AgentActiveSchools,
    beforeEnter: multiguard([preChecks, requireAgentAuth])
  },
  {
    path: "/Agent/ActivedSchools",
    name: "AgentActivedSchools",
    component: AgentActivedSchools,
    beforeEnter: multiguard([preChecks, requireAgentAuth])
  },
  {
    path: "/Agent/Payments",
    name: "AgentPayments",
    component: AgentPayments,
    beforeEnter: multiguard([preChecks, requireAgentAuth])
  },
  {
    path: "/MyExams",
    name: "MyExams",
    component: MyExams,
    beforeEnter: multiguard([preChecks, requireAuth])
  },
  {
    path: "/MyOrders",
    name: "MyOrders",
    component: MyOrders,
    beforeEnter: multiguard([preChecks, requireAuth])
  },
  {
    path: "/Buy",
    name: "Buy",
    component: Buy,
    beforeEnter: preChecks
  },
  {
    path: "/Restricted",
    name: "Restricted",
    component: Restricted,
    beforeEnter: preChecks
  },
  {
    path: "/portal/404",
    name: "PortalNotExist",
    component: PortalNotExist
  },
  {
    path: "/SchoolRegister",
    name: "SchoolRegister",
    component: SchoolRegister,
    beforeEnter: multiguard([preChecks, loginedUser])
  },
  {
    path: "/Books",
    name: "Books",
    component: Books,
    beforeEnter: preChecks
  },
  {
    path: "/Book/Get/:id",
    name: "Book",
    component: Book,
    beforeEnter: multiguard([preChecks, perchasedBook])
  },
  {
    path: "/Book/Reading/:id",
    name: "Reading",
    component: Reading,
    beforeEnter: multiguard([preChecks, perchasedBook])
  },
  {
    path: "/Book/Listening/:id",
    name: "Listening",
    component: Listening,
    beforeEnter: multiguard([preChecks, perchasedBook])
  },
  {
    path: "/Book/Watching/:id",
    name: "Watching",
    component: Watching,
    beforeEnter: multiguard([preChecks, perchasedBook])
  },
  {
    path: "/Book/Exam/:id",
    name: "Exam",
    component: Exam,
    beforeEnter: multiguard([preChecks, requireAuth, perchasedBook])
  },
  {
    path: "/Book/Report/:id",
    name: "Report",
    component: Report,
    beforeEnter: multiguard([preChecks, requireAuth, perchasedBook, hasNoExam])
  },
  {
    path: "/Book/Certificate/:id",
    name: "Certificate",
    component: Certificate,
    beforeEnter: multiguard([preChecks, requireAuth, perchasedBook, hasNoExam])
  },
  {
    path: "/Order/Checkout/:id",
    name: "Checkout",
    component: Checkout,
    beforeEnter: multiguard([preChecks, requireAuth])
  },
  {
    path: "/Order/Verify/:id",
    name: "OrderVerify",
    component: OrderVerify,
    beforeEnter: multiguard([preChecks, requireAuth])
  },
  {
    path: "/Portal/Details",
    name: "Portal",
    component: Portal,
    beforeEnter: multiguard([preChecks, requirePortalAuth])
  },
  {
    path: "/Portal/Payments",
    name: "PortalPayments",
    component: PortalPayments,
    beforeEnter: multiguard([preChecks, requirePortalAuth])
  },
  {
    path: "/Portal/Students",
    name: "PortalStudents",
    component: PortalStudents,
    beforeEnter: multiguard([preChecks, requirePortalAuth])
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
